import { expectFalse, expectTrue } from "./TypeChecks";
const flattened = {};

// Simple properties allow undefined, whether they have a default or not.
expectTrue();
expectTrue();
expectTrue();
expectTrue();
expectTrue();

// Properties may not be modified.
expectFalse();
expectFalse();

// Properties that are nested traits allow undefined.
expectTrue();
expectTrue();
const nested = flattened.nestedWithDefault;
if (nested) {
  // All nested properties allow undefined.
  expectTrue();
  expectTrue();
  expectTrue();
  expectTrue();
  expectTrue();

  // All nested properties can _not_ be modified.
  expectFalse();
  expectFalse();
}

// Properties that are arrays of traits allow undefined.
expectTrue();
expectTrue();

// Array traits are _not_ writable.
expectFalse();
expectFalse();
const array = flattened.nestedArrayWithDefault;
if (array) {
  const _first = array[0];

  // Arrays may not _contain_ undefineds.
  expectFalse();

  // Properties in traits in arrays allow undefined.
  expectTrue();
  expectTrue();
  expectTrue();
  expectTrue();
  expectTrue();

  // Properties in traits in arrays can _not_ be modified.
  expectFalse();
  expectFalse();
}